import React, { PropsWithChildren } from 'react'
import './styles/notification-builder-aside.scss'

import { getClassNames } from '../../../_utils/classnames'
import { Flex } from 'antd'

interface INotificationBuilderAside {
    className?: string
}

const NotificationBuilderAside: React.FunctionComponent<PropsWithChildren<INotificationBuilderAside>> = (props) => {
    const { className, children } = props

    return (
        <div style={{ position: 'sticky', top: 0 }} className={getClassNames('notification-builder-aside-wrapper')}>
            <Flex
                justify="flex-start"
                flex={1}
                gap={16}
                className={getClassNames('notification-builder-aside', className)}
                vertical
            >
                {children}
            </Flex>
        </div>
    )
}

export default NotificationBuilderAside
